<section class="db-add-ecommerce-sidebar-wrapper" (click)="$event.stopPropagation()">
  <i class="modal-close db-icon db-icon-ds-close-bg" (click)="closeSidebar.emit()"></i>
  <div class="db-add-ecommerce-sidebar-header">
    <div class="sidebar-title mb20">{{ 'text_addMenuItems' | dbText }}</div>
    <div class="sidebar-search">
      <ds-search-input [placeholder]="'text_searchEllipsis' | dbText"
                       [formControl]="searchForm"
                       [hasSearchIcon]="true"></ds-search-input>
    </div>
  </div>
  <ng-container *ngIf="!searchForm.value;else searchResult">
    <db-ecommerce-menu-sidebar-items [showCreateCustom]="showCreateCustom"
                                     [types]="types"
                                     [allTypeItems]="allTypeItems"
                                     (addNewMenuItem)="addNewMenuItem($event)"></db-ecommerce-menu-sidebar-items>
  </ng-container>
  <ng-template #searchResult>
    <db-ecommerce-menu-search [allTypeItems]="allTypeItems"
                              (addNewMenuItem)="addNewMenuItem($event)"
                              [searchTerm]="searchForm.value"></db-ecommerce-menu-search>
  </ng-template>
</section>
